import { useAuditLayoutStore } from '../hooks/useAuditLayoutStore';

export function AuditColumn({ children }: { children: React.ReactNode }) {
  const { columnWidthEx } = useAuditLayoutStore();
  return (
    <div className="flex flex-col flex-shrink-0 gap-2" style={{ width: `${columnWidthEx}ex` }}>
      {children}
    </div>
  );
}
